<template>
  <section id="testimonials">
    <div class="h-screen">
      <div class="h-full flex flex-col justify-center">
        <div class="text-center mb-10 -mt-36 exp">
          <p>***</p>
          <p
            data-aos="fade-right"
            data-aos-offset="300"
            data-aos-duration="1000"
            data-aos-easing="ease-in-sine"
            class="scroll__sub__headers font-bold"
          >
            Testimonials
          </p>
        </div>
        <div class="flex justify-center">
          <div class="swiper swiper_container">
            <div class="swiper-wrapper w-64 md:w-full mb-10">
              <carousel
                :autoplay="9000"
                :breakpoints="breakpoints"
                :settings="settings"
              >
                <slide v-for="slide in dt" :key="slide" v-html="slide"> </slide>
                <template #addons>
                  <navigation />
                  <pagination />
                </template>
              </carousel>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Pagination, Navigation } from "vue3-carousel";

export default {
  name: "App",
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
  data() {
    return {
      dt: [
        `<div class="menu_bar_bg swiper_rounded p-3">
                                <img src="images/image_1.jpg" class="rounded-full mx-auto w-32 h-32 object-cover"
                                    alt="">
                                <div>
                                    <p class="text-white">Mr . John doe</p>
                                    <p class="text-white text-xs ">project manager</p>
                                    <p class="w-44 h-32 text-sm indent-8 text-white"> <span
                                            class="font-bold text-4xl text-blue-500 italic">"</span> Eazy platform to
                                        use, fantastic staff and awesome. <span
                                            class="font-bold text-4xl text-blue-500 italic">"</span> </p>
                                </div>
                            </div>`,
        `<div class="menu_bar_bg  swiper_rounded p-3">
                                <img src="images/image_3.jpg" class="rounded-full mx-auto w-32 h-32 object-cover"
                                    alt="">
                                <div>
                                    <p class="text-white">Mr . Sandman</p>
                                    <p class="text-white text-xs ">Marketing Manager</p>
                                    <p class="w-44 h-32 text-sm indent-8 text-white"> <span
                                            class="font-bold text-4xl text-blue-500 italic">"</span>You have been the
                                        most helpful site I have ever been on. You're awsome.<span
                                            class="font-bold text-4xl text-blue-500 italic">"</span> </p>
                                </div>
                            </div>`,
        ` <div class="menu_bar_bg  swiper_rounded p-3">
                                <img src="images/image_2.jpg" class="rounded-full mx-auto w-32 h-32 object-cover"
                                    alt="">
                                <div>
                                    <p class="text-white">Ms . John</p>
                                    <p class="text-white text-xs ">user</p>
                                    <p class="w-44 h-32 text-sm indent-8 text-white"> <span
                                            class="font-bold text-4xl text-blue-500 italic">"</span> Nice place to read
                                        awesome blogs. <span class="font-bold text-4xl text-blue-500 italic">"</span>
                                    </p>
                                </div>
                            </div>`,
      ],
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      breakpoints: {
        // 700px and up
        700: {
          itemsToShow: 2,
          snapAlign: "center",
        },
        // 1024 and up
        1024: {
          itemsToShow: 2,
          snapAlign: "start",
        },
      },
    };
  },
};
</script>
<style>

 .carousel__next {
  margin-right: 40px;
  margin-top: -41px;
}
.carousel__prev {
  margin-left: 40px;
  margin-top: -41px;
}

.carousel__prev--in-active,
.carousel__next--in-active {
  display: none;
}
</style>
